export default "__VITE_ASSET__W5QvL09E__"